import ChargeAppointmentButton from './ChargeAppointmentButton';

export default ChargeAppointmentButton;
